module.exports = __webpack_public_path__ + "img/icon-venture-capital.e4bdbb30.svg";